/* global System */

export default {
  ServiceTeaser: () =>
    System.import(/* webpackChunkName: "ServiceTeaser" */ './index'),
}
